// Removed unused individual class exports

import { cleric } from "./cleric";
import { fighter } from "./fighter";
import { magicUser } from "./magic-user";
import { thief } from "./thief";
import { assassin } from "./assassin";
import { barbarian } from "./barbarian";
import { druid } from "./druid";
import { illusionist } from "./illusionist";
import { necromancer } from "./necromancer";
import { ranger } from "./ranger";
import { paladin } from "./paladin";
import { scout } from "./scout";
import { spellcrafter } from "./spellcrafter";
import { fighterMagicUser } from "./fighter-magic-user";
import { magicUserThief } from "./magic-user-thief";
import { illusionistThief } from "./illusionist-thief";

export const allClasses = [
  cleric,
  fighter,
  magicUser,
  thief,
  assassin,
  barbarian,
  druid,
  illusionist,
  necromancer,
  ranger,
  paladin,
  scout,
  spellcrafter,
  fighterMagicUser,
  magicUserThief,
  illusionistThief,
];
